import { isFunction, isObject } from './typeUtils';

/**
 * Build a dictionary from an object, using a key and/or a value to retrieve object's data
 * @param {*} object Any object used to build the dictionary (can be an array or an enum for exemple)
 * @param {*} key The object property's name used to retrieve the value as the dictionary key
 * @param {*} value The object property's name used to retrieve the value as the dictionary value
 * @returns {Array} Dictionary
 */
const buildDictionary = (object, key, value = null) => {

    // The key is mandatory
    if (key === null || key === undefined || key.trim() === '') { return null; }

    // In case value is null, the key is used for both key/value retrieving
    if (key && value === null) { value = key; }

    if (Array.isArray(object)) {
        const dictionary = object.map(element => ({
            name: element[key],
            value: element[value]
        }));
        return dictionary;
    }

    // Functions are not supported (but they are objects so...)
    if (isFunction(object)) { return null; }

    if (isObject(object)) {
        // eslint-disable-next-line no-unused-vars
        const dictionary = Object.entries(object).map(([elemKey, elemValue]) => ({
            name: elemValue[key],
            value: elemValue[value]
        }));
        return dictionary;
    }
    return null;
};

export default buildDictionary;